import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import Checkbox from '@repo/ui/checkbox'
import Typography from '@repo/ui/typography'
import { useFormContext } from 'react-hook-form'
import { toast } from 'sonner'

import { SendEmailInput } from '../../../lib/types/models/mail/create-mail-attachment'

interface Props {
  parisContactEmails: string[]
}

export default function CcParisContactsCheckbox({ parisContactEmails }: Props) {
  const { watch, setValue } = useFormContext<SendEmailInput>()
  const cc = watch('cc') ?? []
  const checked =
    parisContactEmails.length > 0 && parisContactEmails.every((email) => cc.includes(email))

  const onChange = (isChecked: boolean) => {
    if (isChecked && !parisContactEmails.length) {
      toast.error("Aucun contact à Paris n'a été trouvé parmi les prestataires sélectionnés")
      return
    }
    const nextCc = isChecked
      ? Array.from(new Set([...cc, ...parisContactEmails]))
      : cc.filter((email) => !parisContactEmails.includes(email))
    setValue('cc', nextCc, { shouldDirty: true, shouldValidate: true })
  }

  return (
    <div className="flex items-center gap-2">
      <Checkbox checked={checked} onChange={onChange} />
      <Typography variant="tag" color={tailwindColors.grey.DEFAULT}>
        Mettre le <span className="text-primary">contact à Paris</span> en copie dans l'email
      </Typography>
    </div>
  )
}
